import type { ActionContext } from 'vuex'
import type { ActionClass, IndexClientDTO, IndexState } from '../../../models'
import type { IndexClientService } from '../../../services/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { INDEX_CONSTS } from '../index.consts'

export class GetClientAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit }: ActionContext<IndexState, unknown>,
    id: string,
  ): Promise<IndexClientDTO> {
    if (!state.clients.hasOwnProperty(id)) {
      const clientService = CONTAINER.get<IndexClientService>(TYPES.IndexClientService)
      const client = await clientService.read(id)
      commit(INDEX_CONSTS.mutations.setClient, client)
    }
    return state.clients[id]
  }
}
